import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {LoadingService} from "../../../services/LoadingService";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {ToastService} from "../../../services/Toast.service";
import {SwitchBoard} from "../../../services/SwitchBoard";
import {TemplatesService} from "../../../tpiq-services/templates.service";
import {Session} from "../../../services/Session";
import {v4 as uuid} from 'uuid';
import {TpiqSelectDropdownComponent} from "../../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {FormatAmountPipe} from "../../../pipes/format-amount.pipe";
import {TemplateStrategiesComponent} from "./template-strategies/template-strategies.component";
import {FoundationInit} from "../../../directives/foundation.directive";

declare const _: any;
declare const jQuery: any;

@Component({
  selector: 'app-use-template',
  standalone: true,
  imports: [CommonModule, FormsModule, TpiqSelectDropdownComponent, FormatAmountPipe, TemplateStrategiesComponent, FoundationInit],
  templateUrl: './use-template.component.html',
  styleUrl: './use-template.component.scss'
})
export class UseTemplateComponent implements OnInit, OnDestroy {
  user: any;
  org: string;
  @Input() template: any;
  @Input() clients: any;
  @Input() taxPlanId: any;
  @Input() stateAssociatedData: any;
  @Input() planYear: any;
  @Input() allAssociatedData: any;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  currentView = 'strategies';
  feesTableColumns: Array<any> = [
    {name: 'description', title: 'Description', type: 'normal', classes: 'pointer zero-overflow'},
    {name: 'amount', title: 'Amount', type: 'normal', classes: 'pointer zero-overflow'},
    {name: 'associatedWithName', title: 'Associated With', type: 'input-currency', classes: 'strategy-column pointer zero-overflow table-header-badge-tooltip'},
    {name: 'year', title: 'Year', type: 'input-currency', classes: 'input-currency amount-column pointer zero-overflow amount-column-width table-header-badge-tooltip'}
  ];
  @Output() triggerApplyTemplate: EventEmitter<any> = new EventEmitter<any>();
  years: Array<any> = [];
  associatedWith: Array<any> = [
    {id: 'a627ccde-dd57-1090-cefa-fc965526a557', name: 'Effective Rate'},
    {id: '82c36191-8d6f-39e7-f711-947591551608', name: 'Marginal Rate'},
    {id: '5a314bc1-4534-0426-1db4-d18403485072', name: 'Cap Gain Rate'},
    {id: '23a5e1b2-03cf-6675-2596-0952387d4b46', name: 'C Corp Flat Rate'},
    {id: 'b870c7b6-802f-11eb-8aa0-1282986503dc', name: 'Non-deductible'},
    {id: 'f637945b-e78e-11ef-a4a7-0e0adc17208f', name: 'Market Growth Rate'},
    {id: 'ca57f1ef-ebb8-d007-66f5-59a3297f0502', name: 'SE Tax Rate'},
    {id: '393a6f91-8222-11ef-bd9d-12ff30f54e53', name: 'Full Credit'},
    {id: '454ba189-8222-11ef-bd9d-12ff30f54e53', name: 'N/A'}
  ];
  editing: any = {};
  tempNames: any = {};
  temp: any = {};
  templateRates: any;
  constructor(
    private toastService: ToastService,
    private loadingService: LoadingService,
    private switchBoard: SwitchBoard,
    private templatesService: TemplatesService
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
    this.switchBoard.onToggleFeedback.next({
      display: false
    });
  }

  ngOnInit(): void {
    this.user = Session.getUser();
    this.org = Session.getOrg();
    this.fillYears();
    if (this.template) {
      _.each(this.template.rates, (rate) => {
        rate.id = uuid();
      });
      this.templateRates = this.template.rates;
    }
  }

  switchPage(view){
    this.currentView = view;
    jQuery('#a-rates').attr('aria-selected', 'false');
    jQuery('#a-fees').attr('aria-selected', 'false');
    jQuery('#a-strategies').attr('aria-selected', 'false');
    jQuery('#a-' + view).attr('aria-selected', 'true');
  }

  deleteRate(index) {
    this.template.rates.splice(index, 1);
  }

  deleteFees(index) {
    this.template.fees.splice(index, 1);
  }

  applyTemplate() {
    if (!this.validateStrategiesData()){
      return;
    }
    const temData = _.cloneDeep(this.template);
    _.each(temData.fees, (fee) => {
      fee.id = '';
      fee.frequency = 'Yearly';
      fee.type = 'Third Party';
    });
    _.each(temData.strategies, (strategy) => {
      strategy.id = '';
      delete strategy.riskLevelDisplay;
    });
    const obj: any = {};
    obj.rates = temData.rates || [];
    obj.fees = temData.fees || [];
    obj.applyStrategies = temData.strategies || [];
    this.loadingService.triggerLoadingEvent(true);
    this.templatesService.applyTemplate(this.org, this.user.id, obj, this.taxPlanId).subscribe(response => {
      this.loadingService.triggerLoadingEvent(false);
      this.toastService.pop(TOAST_TYPE.success, 'Template applied Successfully');
      this.triggerApplyTemplate.emit();
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
      this.toastService.pop(TOAST_TYPE.error, 'Failed to apply template');
    });
  }

  validateStrategiesData(){
    const base = this;
    let result = true;

    if (this.template.strategies && this.template.strategies.length > 0) {
      result = true;
      _.each(this.template.strategies, (strategy) => {
        if (!strategy.clientId || !strategy.sinceYear || !strategy.associatedWith){
          result = false;
        }
      });
      if (!result) {
        base.toastService.pop(TOAST_TYPE.error, `Strategies exist and have mandatory inputs on that tab.`);
        return false;
      }
    }

    if (this.template.fees && this.template.fees.length > 0) {
      _.each(this.template.fees, (fee) => {
        if (!fee.associatedWith || !fee.year){
          result = false;
        }
      });
      if (!result) {
        base.toastService.pop(TOAST_TYPE.error, `Fee's exist and have mandatory inputs on that tab.`);
        return false;
      }
    }

    return result;
  }

  fillYears(){
    for (let i = this.planYear; i < (this.planYear + 10); i++){
      this.years.push({id: i, name: i.toString()});
    }
  }

  setYear($event, feeData) {
    feeData.year = $event.id;
  }

  setAssociatedWith($event, data) {
    data.associatedWithName = $event.name;
    data.associatedWith = $event.id;
  }

  toggleField(key, value, rate?){
    this.editing[key] = value;
    if (rate){
      this.tempNames[key] = rate.name;
      this.temp[key] = rate.rate;
    }
  }

  updateValue(key){
    let editedRate: any;
    editedRate = this.template.rates[key];
    editedRate.rate = this.temp[key];
    editedRate.name = this.tempNames[key];
    this.toggleField(key, false);
  }

  revertValue(key){
    this.temp[key] = 0;
    this.toggleField(key, false);
  }

}
